import { render } from "./EditMyPage.vue?vue&type=template&id=57ff8edd&scoped=true"
import script from "./EditMyPage.vue?vue&type=script&lang=js"
export * from "./EditMyPage.vue?vue&type=script&lang=js"

import "./EditMyPage.vue?vue&type=style&index=0&id=57ff8edd&scoped=true&lang=css"

import exportComponent from "D:\\Xoan\\asp-user\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57ff8edd"]])

export default __exports__